class VwKurumDTO {
  id?: number = null;
  adi?: string = "";
  adres?: string = "";
  fkHbsUcretTarifetanimId?: number = null;
  aktif?: string = "E";
  aktifBool?: boolean = true;
  ekleyenKullanici?: number = null;
  eklemeTarihi?: string = null;
  guncelleyenKullanici?: number = null;
  guncellemeTarihi?: string = null;
  searchText?: string = "";
  calisanBilgileri?: number = null;
  alisKanalmaTarZorunlu?: string = "H";
  alisKanalmaTarZorunluBool?: boolean = false;
  kurumgrupId?: number = null;
  kurumtip?: number = 1;
  kurumtipad?: string = "";
  sevkAktif?: string = "H";
  sevkAktifBool?: boolean = false;
  ilacMalzemeFiyatYontemi?: number = 1;
  ilacMalzemeCarpan?: number = 1;
  sonucKontrolAktif?: string = "H";
};
export default VwKurumDTO;